import styled from 'styled-components';
import DetailsTable from '../../TransactionsPage/DetailsTable';
import {bordersStyles} from '../../../../utils/styles';

const StyledBudgetDetails = styled.div`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 16px 24px;
`;

const StyledBudgetDetailsTable = styled(DetailsTable)`
  tr {
    min-height: 34px;

    &:not(:last-of-type) {
      margin-bottom: 0;
    }
  }
`

export {
  StyledBudgetDetails,
  StyledBudgetDetailsTable
}
